import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { Loading } from "models/enums/loading";
//#endregion
//#region components
import { MasonryPanel, ViewPanel, WidgetArea } from "components/common";
import { SomethingWentWrongLoadingTodos, TodosWidget } from "components/todos";
import ShortcutsWidget from "./widgets/shortcuts/widget";
import TimeLineWidget from "./widgets/timeline/widget";
import { CompanyInfoWidget } from "components/company";
import RevisorFAQWidget from "./widgets/faq/widget";
import OwnersWidgetForRevisor from "./widgets/ownersWidget";
import AuditorCaseWidget from "./widgets/auditorCase/widget";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const RevisorViewDashboardContent: React.FC = () => {
  const failedToLoadTodos = useSelector((store: AppState) => store.todos.todoSummaryLoadingState === Loading.Failure);

  return (
    <MasonryPanel breakpointCols={{ default: 2, 1280: 1 }}>
      <WidgetArea>
        {failedToLoadTodos ? <SomethingWentWrongLoadingTodos /> : <TodosWidget />}
        <TimeLineWidget />
        <AuditorCaseWidget />
      </WidgetArea>

      <WidgetArea>
        <ShortcutsWidget />
        <RevisorFAQWidget />
      </WidgetArea>

      <WidgetArea>
        <OwnersWidgetForRevisor />
        <ViewPanel
          icon={IconDefinitionConstants.WCompany}
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Reports.CompanyInformation)}
          appearance="lg"
          gridSize="lg"
        >
          <CompanyInfoWidget />
        </ViewPanel>
      </WidgetArea>
    </MasonryPanel>
  );
};

export default RevisorViewDashboardContent;
